import React from "react";
import { Box } from "../../primitives";
import { FormWrapperProps } from "./FormWrapper.types";

/**
 * A `<form>` that disables all its fields at once while saving (`isLoading`) or when read-only
 * (`isDisabled`), with a white veil over it. Native validation is off (`noValidate`): validate
 * with react-hook-form.
 */
export const FormWrapper: React.FC<FormWrapperProps> = ({
  children,
  onSubmit,
  isDisabled,
  isLoading,
  isFormContainer = true,
  formProps,
  className,
  ...rest
}) => {
  const shouldDisableForm = isDisabled || isLoading;

  return (
    <Box
      className={[
        "w-full",
        shouldDisableForm ? "relative" : undefined,
        className
      ]}
      {...rest}
    >
      {isFormContainer ? (
        <form
          noValidate
          className="h-full"
          onSubmit={(e) => {
            e.stopPropagation();
            e.preventDefault();

            if (onSubmit) {
              onSubmit(e);
            }
          }}
          {...formProps}
        >
          <fieldset disabled={shouldDisableForm} className="h-full">
            {children}
          </fieldset>
        </form>
      ) : (
        <fieldset disabled={shouldDisableForm} className="h-full">
          {children}
        </fieldset>
      )}
      {shouldDisableForm && (
        <Box
          className={"absolute inset-0 z-index-overlay bg-white opacity-40"}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        />
      )}
    </Box>
  );
};
